module.exports = __webpack_public_path__ + "img/44.a315d18e.png";